import React, { useEffect, useState } from 'react';
import { Panel } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';

// The mapping lives in its own table, so it is fetched here rather than read off the project.
export default function MicrosoftTeamsChannel({ project }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const isMounted = useIsMounted();
  const [channel, setChannel] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.www.workspaces(workspace.id).integrations().microsoft.teams.getProjectChannels();
        if (isMounted.current) setChannel(data.find((row) => row.projectId === project.id) ?? null);
      } catch {
        if (isMounted.current) setChannel(null);
      }
    })();
  }, [api, workspace.id, project.id, isMounted]);

  if (!channel) return null;

  const label = channel.teamName ? `${channel.teamName} / ${channel.channelName}` : channel.channelName;

  return (
    <Panel.Info title="Microsoft Teams Channel">
      {channel.webUrl ? (
        <a href={channel.webUrl} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      ) : (
        label
      )}
    </Panel.Info>
  );
}
